import React, { useState, useEffect } from 'react';
import { Modal, Text, ModalFooter } from '@stitch-fix/mode-react';

const BagInventoryFailureModal = () => {
  const params = new URLSearchParams(window.location.search);
  const [isOpen, setIsOpen] = useState(!!params.get('inventory_failure'));

  useEffect(() => {
    if (isOpen) {
      // remove the param without reloading page or altering history
      window.history.replaceState({}, '', '/product/shopping_bag');
    }
  }, [isOpen]);

  const footer = (
    <ModalFooter
      primaryAction={{
        text: 'Got it',
        onClick: () => {
          setIsOpen(false);
        },
      }}
    />
  );

  return (
    <Modal
      isOpen={isOpen}
      variant="inset-small"
      onClose={() => setIsOpen(false)}
      hAlign="center"
      heading="Sorry, some items have just sold out"
      footer={footer}
    >
      <Text color="gray-16" setting="body-medium">
        Please review your bag before continuing to checkout.
      </Text>
    </Modal>
  );
};

export default BagInventoryFailureModal;
